
<div class="modal-body">
  <h4><i *ngIf="icon === 'check'" class="fa fa-check-circle {{iconCss}}" aria-hidden="true"></i>
  <i *ngIf="icon === 'exclamation'" class="fa fa-exclamation-circle {{iconCss}}" aria-hidden="true"></i> {{message}}</h4>
</div>
<div class="footeButtons p-3">
  <button type="button" (click)="close()" tabindex="-1" class="btn btn-primary w-100">Close</button>
</div>
